import React from 'react';
import Sidebar from '../component/layout/sidebar';
import Header from '../component/layout/header';
import { useState } from 'react';
import Cta from '../component/common/cta';
import pic32 from '../assets/pic32.png'
import './error.css'


const Error = () => {
      const [isSidebarOpen, setIsSidebarOpen] = useState(false)
    return ( 
        <section className='main-dashboard-container'>            
            <Sidebar isOpen={isSidebarOpen}  /> 
            <section className='container-right-info'>
                    <section className='header-container'>
                        <Header  onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}  />
                    </section>

                <section className='information-container'>

                    <section className='sec1-sub-errorr'>
                        <article className='container-header'>
                            <h1 className='error-header'>404</h1>
                             <img className='img-error' src={pic32} alt='light pic'></img>
                        </article>
                            <h3 className='sectence-header'>Page not found!</h3>
                            <button className='cta-cont-error' >
                            <Cta title='Back to Dashboard' to="/dashboard"  />
                            </button>



                    </section>

                    
                </section>

            </section>
    </section>
     );
}
 
export default Error;